jQuery(document).ready(function($) {

  // Sticky header
  var $newHeader = $('.new-header');
  var $body = $('body');
  var $videoBox = $('.video-row');
  var $videoDesc = $('.about-container');

  $(window).scroll(function(){
    if ($(this).scrollTop() >= 36){
      $newHeader.addClass('sticky');
      $body.addClass('sticky');
      $videoBox.removeClass('videoStickyHead');
      $videoDesc.removeClass('videoStickyHeadDesc');
    } else {
      $newHeader.removeClass('sticky');
      $body.removeClass('sticky');
      $videoBox.addClass('videoStickyHead');
      $videoDesc.addClass('videoStickyHeadDesc');
    }

  });

  // Desktop navigation

  var $navItem = $newHeader.find('li');

  // this needs to be either a or button
  var $navItemLink = $newHeader.find('.top-link');

  var $imagesWrappers = $('.new-header__images-wrapper');
  var $subnavItem = $('.new-header__subnav-item');
  var $subnavItemLink = $('.new-header__subnav-item a');
  var $topLevelNavItem = $('.new-header__nav-item');
  var $topLevelNavItemLink = $('.top-link');

  var $mainDefaultNavDelay = 750; 
  var $mainNavDelay = $mainDefaultNavDelay; //in ms

  $newHeader.on("mouseenter",function(){
      $mainNavDelay = $mainDefaultNavDelay;
  });
  $newHeader.on("mouseleave",function(){
      $mainNavDelay = $mainDefaultNavDelay;
  });


  // show image wrapper 
  $navItem.on('mouseenter', function () { 
    
    if (!$(this).hasClass('submenu-open')) {
      var itemTitle = $(this).data('title');
      var $imagesWrapper = $('.new-header__images-wrapper[data-title="' + itemTitle + '"]');

      if ($imagesWrapper.length !== 0) {
        if (!$imagesWrapper.is(':visible')) {
          $imagesWrappers.removeClass('show-image');
         $imagesWrapper.addClass('show-image');
        }
      } else {
        var parentItemTitle = $('li[data-title="' + $(this).data('parent') + '"]').data('title');
        $imagesWrapper = $('.new-header__images-wrapper[data-title="' + parentItemTitle + '"]');

        if ($imagesWrapper.length !== 0) {
          if (!$imagesWrapper.is(':visible')) {
           $imagesWrappers.removeClass('show-image');
          $imagesWrapper.addClass('show-image');
          }
        }
      }
    }
  });
  
$(document).ready(function() {

 var menuLeaveTimer = '';
 var menuEnterTimer = '';
  $('.new-header__subnav-item.has-submenu').mouseenter(function (e1) {
      var thisItem = $(this);
      clearTimeout(menuLeaveTimer);
      menuEnterTimer = setTimeout(function (e1) {
          if ($(thisItem).hasClass('submenu-open')) {
              return;
          } else {
              $(thisItem).addClass('submenu-open').attr('aria-expanded', 'true');
              $(thisItem).siblings().removeClass('submenu-open').attr('aria-expanded', 'false');
          }

      }, 200);

  }).mouseleave(function (e2) {
      var thisItem = $(this);
      clearTimeout(menuEnterTimer);
      menuLeaveTimer = setTimeout(function (e2) {
          if (!$(thisItem).hasClass('submenu-open')) {
              return;
          } else {
              $(thisItem).removeClass('submenu-open').attr('aria-expanded', 'false');
              $(this).parent().find('li').removeClass('submenu-open').attr('aria-expanded', 'false');
          }
      }, 500);
  });

});


  $subnavItem.on('keydown click', function() {
    if (event.keyCode === 13) { // enter 
      if (!$(this).hasClass('submenu-open')){
        if ($(this).hasClass('has-submenu')){
          var $parentItems = $(this).parents('.new-header__subnav-item.has-submenu');
          $subnavItem.not($parentItems).removeClass('submenu-open').attr('aria-expanded', 'false');
          $(this).addClass('submenu-open').attr('aria-expanded', 'true');
        } else {
          $(this).parent().find('li').removeClass('submenu-open').attr('aria-expanded', 'false');
        }
      }else{
        $(this).removeClass('submenu-open').attr('aria-expanded', 'false');
      }
    }
    if (event.keyCode === 27) {
      window.setTimeout(function() {
        // reset submenus
        $mobileSubnav.removeClass('open').hide();
      }, 500);
      $(this).attr('aria-expanded', 'false');
    }
  });

  $topLevelNavItem.on('mouseleave', function() {
     $(this).find('.new-header__megamenu-container').css('visibility','hidden');
    //$('.announcement-bar__slider').slick('resize'); 
    $(this).find('li').removeClass('submenu-open');
    // $(this).find($navItemLink).attr('aria-expanded', 'false');  
    $(this).find('.new-header__megamenu-container').removeClass('open');
    $('body').removeClass('no-overflow');
    $('.top-link').parent().find('li.has-submenu').each(function() {
      if ($(this).attr('aria-expanded', 'true')) {
        $(this).attr('aria-expanded', 'false');
      }
    });
  });

  $topLevelNavItem.on('mouseenter', function() { 
      $(this).find('.new-header__megamenu-container').css('visibility','hidden');
     // $('.announcement-bar__slider').slick('resize'); 
      // $(this).find($navItemLink).attr('aria-expanded', 'true');
      $(this).find('.new-header__megamenu-container').addClass('open');
      $('body').addClass('no-overflow');
      var currentTopLevelContainer =$(this).find('.new-header__megamenu-container');
      setTimeout(() => {  currentTopLevelContainer.css('visibility','visible');   $mainNavDelay=750; }, $mainNavDelay); 
  });

  $topLevelNavItemLink.on('focusout', function () {
    $(this).parent().find('li').removeClass('submenu-open');
  }); 

  function closeMenu() {
    $('.new-header__nav-item').each(function() {
      if($(this).find('.new-header__megamenu-container').css('visibility', 'visible')) {
        $(this).find('.new-header__megamenu-container').removeClass('open').css('visibility', 'hidden');
        // $(this).find($topLevelNavItemLink).attr('aria-expanded', 'false');
        $('body').removeClass('no-overflow');
      }
    });

    $subnavItem.each(function() {
      if ($(this).attr('aria-expanded', 'true')) {
        $(this).attr('aria-expanded', 'false');
      }
    }); 
 
  }

  // navigate the top links with arrow keys
  $topLevelNavItem.keydown(function(e) {
    if (e.keyCode == 37) { // left
      $(this).prev().find($topLevelNavItemLink).focus();
    } 
    else if (e.keyCode == 39) { // right
      $(this).next().find($topLevelNavItemLink).focus();
    }
  });

  // only open menus on click, then close on escape
  $navItemLink.on('keydown', function (event) { 
    if (event.keyCode == 13) {
      var mega_menu = $(this).parent().find('.new-header__megamenu-container');
      if($(this).parent().find('.new-header__megamenu-container').hasClass('open')) {
        $(this).parent().find('.new-header__megamenu-container').css('opacity','');
        $(this).parent().find('.new-header__megamenu-container').removeClass('open');
        $(this).parent().find('.new-header__megamenu-container').css('visibility','hidden');
        // $(this).parent().find($navItemLink).attr('aria-expanded', 'false');
       
        $('.top-link').parent().find('li.has-submenu').each(function() {
          if ($(this).attr('aria-expanded', 'true')) {
            $(this).attr('aria-expanded', 'false');
          }
        }); 
        $('body').removeClass('no-overflow');
      }else{
        $(this).parent().find('.new-header__megamenu-container').css('visibility','hidden');
        $(this).parent().find('.new-header__megamenu-container').css('opacity','1');
     // $('.announcement-bar__slider').slick('resize'); 
      // $(this).parent().find($navItemLink).attr('aria-expanded', 'true');
      $(this).parent().find('.new-header__megamenu-container').addClass('open');
      $('body').addClass('no-overflow');
      var currentTopLevelContainer =$(this).parent().find('.new-header__megamenu-container');
     
      setTimeout(() => {  currentTopLevelContainer.css('visibility','visible');   $mainNavDelay=0; }, $mainNavDelay);
      }
    } 

    if (event.keyCode == 27) {
      closeMenu();
    }
    
  }); 

  $('.menu-close').on('keydown', function(e) {
    if (e.keyCode === 13) {
      e.preventDefault();
      closeMenu();
      $(this).parent().parent().find('.top-link').focus();
    }
  });


  $(document).keydown(function(e) {
    var $regionSearch = $('.region-search');
    var $searchBar = $('#search_morphe');
    if (e.keyCode == 27) {
      if ($regionSearch.is(':visible')) {
        $regionSearch.fadeOut(500);
        $('.announcement-bar__country-selector').focus();
      } else if ($searchBar.is(':visible')) {
        $('.fast-ac-container').addClass('hidden');
        $searchBar.fadeOut(500);
        $searchIcon.focus();
      } else if ($('.new-header__mobile-nav-container').hasClass('open')){
        if ($hamburger.hasClass('open')){
          window.setTimeout(function() {
            $mobileSubnav.removeClass('open').hide();
          }, 500);
          $hamburger.attr('aria-expanded', 'false');
          // change icon back to hamburger 
          $hamburger.find('img').attr('src', '//www.morphe.com/cdn/shop/t/975/assets/hamburger-icon-black.svg?v=37398962526372985731747154255');
          $hamburger.focus();
        }
        $hamburger.toggleClass('open');
    
        if ($hamburger.hasClass('open') && !$mobileNavigation.hasClass('open')) {
          $mobileNavigation.addClass('open');
          $('body').addClass('no-overflow'); 
          
          $mobileNavigation.find(".new-header__mobile-nav .has-submenu").each(function(i, obj) {        
            if ($(obj).data("background") != undefined &&  $(obj).data("background") != ""){          
              $(obj).find("ul").css({"background":"url('" + $(obj).data("background")+ "')  no-repeat center/cover" });
            }
    
          });
    
        }else if (!$hamburger.hasClass('open')) {
          $mobileNavigation.removeClass('open');
          $('body').removeClass('no-overflow');
        }
      }
      $body.removeClass('fixed');
    }
  });

  // Mobile navigation

  var $hamburger = $('.new-header__hamburger-icon');
  var $mobileNavigation = $('.new-header__mobile-nav-container');
  var $mobileNavItem = $('.new-header__mobile-nav-item-link .arrow');
  var $mobileSubnav = $('.new-header__mobile-subnav');
  var $mobileBackItem = $('.new-header__mobile-subnav-back');
  const targetElement = document.querySelector('#mobile-main-menu');
  const targetSubElement = document.querySelector('.new-header__mobile-subnav');

  $hamburger.on('click', function(e) {
    e.preventDefault();
    // change icon to close
     
    $(this).find('img').attr('src', '//www.morphe.com/cdn/shop/t/975/assets/close-icon-blk.svg?v=10237494249917893291747154224');
    $(this).find('img').attr('alt', 'Close');
    // expanding mobile menu container
    $($mobileNavigation).addClass('open');
    // freeze scroll on page contents
    bodyScrollLock.disableBodyScroll(targetElement);
    $($body).addClass('no-overflow');

    // if menu is already open, close it

    if ($(this).hasClass('open')) {
      window.setTimeout(function() {
        $($mobileNavigation).removeClass('open');
        // reset submenus
        $mobileSubnav.removeClass('open').hide();
        bodyScrollLock.enableBodyScroll(targetElement);
        bodyScrollLock.clearAllBodyScrollLocks();
      }, 500);
      $(this).attr('aria-expanded', 'false');
      // change icon back to hamburger 
      $(this).find('img').attr('src', '//www.morphe.com/cdn/shop/t/975/assets/hamburger-icon-black.svg?v=37398962526372985731747154255');
      $(this).find('img').attr('alt', 'Hamburger menu');
    } else {
      //  reset main menu
      $('.new-header__mobile-nav').children('.new-header__mobile-nav-item').show();
      trapFocus('#shopify-section-new-header');
      $(this).attr('aria-expanded', 'true');
    }

    $(this).toggleClass('open');
    if ($(this).hasClass('open') && !$mobileNavigation.hasClass('open')) {
      $mobileNavigation.addClass('open');
      bodyScrollLock.disableBodyScroll(targetElement);
      $('body').addClass('no-overflow');
      
      $mobileNavigation.find(".new-header__mobile-nav .has-submenu").each(function(i, obj) {
        if ($(obj).data("background") != undefined &&  $(obj).data("background") != ""){
          $(obj).find("ul").css({"background":"url('" + $(obj).data("background") + "') no-repeat center/cover" });
        }

      });

    } else if (!$(this).hasClass('open')) {
      $mobileNavigation.removeClass('open');
      bodyScrollLock.enableBodyScroll(targetElement);
      $('body').removeClass('no-overflow');
    }


    $searchIcon.removeClass('open');
    $searchIcon.attr('aria-expanded', 'false');
    $searchBar.css('display', 'none');

  });

  $('.new-header__mobile-nav-item-link').each(function() {
    $(this).on('click', function() {
      // console.log("submenu opened");
      bodyScrollLock.disableBodyScroll(targetSubElement);
    });
  });

  $('.close-nav').on('click', function(e) {
    e.preventDefault();
    bodyScrollLock.enableBodyScroll(targetElement);
    bodyScrollLock.clearAllBodyScrollLocks();
    // change icon to close
    if ($hamburger.hasClass('open')){
      window.setTimeout(function() {
        $mobileSubnav.removeClass('open');
      }, 500);
      $hamburger.attr('aria-expanded', 'false');
      // change icon back to hamburger 
      $hamburger.find('img').attr('src', '//www.morphe.com/cdn/shop/t/975/assets/hamburger-icon-black.svg?v=37398962526372985731747154255');
      $hamburger.focus();
    } else {
      // reset trap focus
      trapFocus('#shopify-section-new-header');
      $(this).attr('aria-expanded', 'true');
    }

    $hamburger.toggleClass('open');

    if ($hamburger.hasClass('open') || !$mobileNavigation.hasClass('open')) {
      $mobileNavigation.addClass('open');
      $('body').addClass('no-overflow');
      
      $mobileNavigation.find(".new-header__mobile-nav .has-submenu").each(function(i, obj) {        
        if ($(obj).data("background") != undefined &&  $(obj).data("background") != ""){          
          $(obj).find("ul").css({"background":"url('" + $(obj).data("background")+ "')  no-repeat center/cover" });
        }
      });
    } else if (!$hamburger.hasClass('open')) {
      $mobileNavigation.removeClass('open');
      $('body').removeClass('no-overflow');
    }
  });

  $mobileNavItem.on('click', function(e) {
    e.preventDefault();
    $(this).parent().next().show();
    var $parentItem = $(this).parent().parent();
    $parentItem.siblings().toggle();
    var $subnav = $parentItem.find($mobileSubnav).eq(0);
    $subnav.addClass('open');
    trapFocus($subnav);
    // find all the submenus with kiddos
    $parentItem.find(".has-submenu").each(function(i, obj) {
      if ($(obj).data("background") != undefined &&  $(obj).data("background") != ""){     
        $(obj).find("ul").css({"background":"url('" + $(obj).data("background")+ "')  no-repeat center/cover" });
      }
    });
    $(this).siblings().attr("aria-expanded", "true");
  });

  $mobileBackItem.on('click keydown', function(e) {
    if (e.type === 'click' || e.keyCode === 13) { 
      let prevMenu = $(this).parent().parent().parent();
      // if parent is submenu level--1
      if ($(this).parent().hasClass('submenu-level--1')) {
        // to ensure login and region selector are included
        prevMenu = $(this).parent().parent().parent().parent();
      }

      $(this).parent().removeClass('open');
      $(this).parent().hide();
      $(this).parent().parent().siblings().show();
      $(this).parent().prev().attr("aria-expanded","false");
      trapFocus(prevMenu);
    }
  });

//  if e.type === 'click' || e.keyCode === 13

  $('.new-header__mobile-subnav-back').keydown(function (e) {
    switch(e.key) {
      case 'ArrowUp':
        $(this).parent('li').prev('li').find('a:first').focus();
        break;
      case 'ArrowDown':
        $(this).next('li').find('a:first').focus();
        break;
    }
  })

  $('.new-header__mobile-nav-item a').keydown(function (e) {
    switch(e.key) {
      case 'ArrowUp':
        $(this).parent('li').prev('li').find('a:first').focus();
        break;
      case 'ArrowDown':
        $(this).parent('li').next('li').find('a:first').focus();
        break;
      case 'Home':  // optional
        e.preventDefault();  // prevent page scroll
        focusFirstTab();
        break;
      case 'End':  // optional
        e.preventDefault();  // prevent page scroll
        focusLastTab();
        break;
    }
  });

  $('.new-header__mobile-nav-item-link').keydown(function(e) {
    switch(e.key) {
      case 'ArrowUp':
        $(this).parent('li').prev('li').find('a:first').focus();
        break;
      case 'ArrowDown':
        $(this).parent('li').next('li').find('a:first').focus();
        break;
      case 'Home':  // optional
        e.preventDefault();  // prevent page scroll
        focusFirstTab();
        break;
      case 'End':  // optional
        e.preventDefault();  // prevent page scroll
        focusLastTab();
        break;
    }
  });

  // Footer

  var $navHeading = $('.new-footer-main-bar__heading');
  var $navList = $('.new-footer-main-bar__nav');

  $navHeading.on('click', function() {
    
    var mobileScreen = $(window).width() <= 1222; 
    
    if (mobileScreen){
      $(this).toggleClass('open');
      $(this).parent().find($navList).slideToggle(300);
    }
  });

  // Search bar

  var $searchIcon = $('.new-header__search-icon');
  var $closeSearchBarIcon = $('.close-search-bar');
  var $searchBar = $('#search_morphe');
  var $searchForm = $searchBar.find('form');
  var $mobileSubmitBtn = $('.snize-clear-button-container');
  var $searchInput = $('#search-morphe');

  window.setTimeout(function() {
    $searchInput.val('');
  }, 1000);

  $searchIcon.on('click', function(e){
    e.preventDefault();
    //$('.announcement-bar__slider').slick('resize'); 
    $searchForm.prepend('<p class="screen-reader-only">When typing into this search field, autocomplete results will appear</p>');
    if ($(this).hasClass('open')){
      $(this).attr('aria-expanded', 'false');
      window.setTimeout(function() {
        $searchInput.val('');
      }, 500);
    } else {
      $(this).attr('aria-expanded', 'true');
      window.setTimeout(function() {
        trapFocus('#search_morphe');
      }, 500);
    }

    $('.fast-ac-container').removeClass('hidden');
    $hamburger.find('img').attr('src', '//www.morphe.com/cdn/shop/t/975/assets/hamburger-icon-black.svg?v=37398962526372985731747154255');
    $hamburger.removeClass('open');
    $hamburger.attr('aria-expanded', 'false');
    $('.new-header__mobile-nav-container').removeClass('open');

    $(this).toggleClass('open');
    $body.toggleClass('fixed');
    $searchBar.fadeToggle(500);
    $searchInput.focus();
  });

  $searchInput.on('keydown', function(e) {
    if (e.key == "Escape") {
      $('.fast-ac-container').addClass('hidden');
      window.setTimeout(function() {
        $searchInput.val('');
      }, 500);
    }
  });

  $closeSearchBarIcon.on('click', function(){
    //$('.announcement-bar__slider').slick('resize');
    $('.fast-ac-container').addClass('hidden');
    window.setTimeout(function() {
      $searchInput.val('');
    }, 500);
    $searchIcon.attr('aria-expanded', 'false');
    $searchBar.fadeOut(500);
    $body.removeClass('fixed');
  });

  $(window).on('resize', function() {
    var $searchResults = $('.snize-ac-results');
    var searchFormWidth = $searchForm.width();

    $searchResults.css('width', searchFormWidth);
  });

  $mobileSubmitBtn.on('click', function(){
    $(this).parent().submit();
  });

  $('.related-videos-block-container').bind('DOMSubtreeModified', function(){
    $(".focus-here").last().focus();
  });

  if($('.sliderThumb').length > 0 ){
   $('.sliderThumb').find('.slick-slide').each(function(i){
     $(this).find('a').attr({
      'aria-label': 'Go to slide '+ (i + 1) + ' of ' + $('.sliderThumb .slick-slide').length,
    });
   })
  }

  $('.announcement-bar__main-text-link').removeAttr("tabindex");
  $('.announcement-bar__additional-text').find('a').removeAttr("tabindex");

  var tabs;
  var focusedTabIndex = 0;

  $('.filter-tabs').keydown(function(e) {
    tabs = document.querySelectorAll('.filter-clk');
    switch(e.key) {
      case 'ArrowLeft':
        focusPreviousTab();
        break;
      case 'ArrowRight':
        focusNextTab();
        break;
      case 'Home':  // optional
        e.preventDefault();  // prevent page scroll
        focusFirstTab();
        break;
      case 'End':  // optional
        e.preventDefault();  // prevent page scroll
        focusLastTab();
        break;
    }
  });

  $(document).on('keydown', '.flex-wrap', function (e) {
     if(e.key == "ArrowDown") {
       $(this).next().focus();
     }else if(e.key == "ArrowUp") {
       $(this).prev().focus();
     }else if(e.key == "Escape") {
        $('.inner-flex-wrap').css({
            "opacity": 0,
            "height": 0,
            "display": "none",          
            "background-color": "transparent"
        });
        $('.inner-flex-wrap').css('height');
        $('.inner-flex-wrap').css('transition', 'all 2s ease-out');      
        $('.options-wrapper').css({
            'height': '49px',
            'overflow-y': 'hidden'
          });
      }
  });

  $(document).on('keydown', '.sort-by', function (e) {
     if(e.key == "ArrowDown") {
      $(this).next().focus();
     }else if(e.key == "ArrowUp") {
       $(this).prev().focus();
     }else if(e.key == "Escape"){
       $("#myDropdown").css('display', 'none');
     }
  });

  $('.resp-tabs-list').keydown(function(e) {
    tabs = document.querySelectorAll('.resp-tab-item');
    switch(e.key) {
      case 'ArrowLeft':
        focusPreviousTab();
        break;
      case 'ArrowRight':
        focusNextTab();
        break;
      case 'Home':  // optional
        e.preventDefault();  // prevent page scroll
        focusFirstTab();
        break;
      case 'End':  // optional
        e.preventDefault();  // prevent page scroll
        focusLastTab();
        break;
    }
  });

  /**
  Tab selection
  */
  function focusPreviousTab() {
    if(focusedTabIndex > 0) {
      focusedTabIndex -= 1;
    } else {
      focusedTabIndex = tabs.length - 1;
    }
    
    tabs[focusedTabIndex].focus();
  }

  function focusNextTab() {
    if(focusedTabIndex < tabs.length - 1) {
      focusedTabIndex += 1;
    } else {
      focusedTabIndex = 0;
    }

    tabs[focusedTabIndex].focus();
  }

  function focusFirstTab() {
    focusedTabIndex = 0;
    tabs[focusedTabIndex].focus();
  }

  function focusLastTab() {
    focusedTabIndex = tabs.length - 1;
    tabs[focusedTabIndex].focus();
  }

  $('.seek-text.w-embed span').click(function (e) {
    e.preventDefault();
  })

  if($('.hero-text-store-services2-liveText-banner').length > 0){
    $('.hero-text-store-services2-liveText-banner h1').addClass('title-text');
  }

  if($('.hero-text-store-services-liveText-banner').length > 0){
    $('.hero-text-store-services-liveText-banner h1').addClass('title-text');
  }
  // Third party icon override

  // Trap focus 
  function trapFocus(element) {
    var focusableEls = $(element).find('a, object, input, button, iframe, [tabindex]').filter(':visible'),
        firstFocusableEl = focusableEls.first()[0],
        lastFocusableEl = focusableEls.last()[0],
        TABKEYCODE = 9;
        if(firstFocusableEl) firstFocusableEl.focus();
    $(element).on('keydown', function(e) {
        var isTabPressed = (e.key === 'Tab' || e.keyCode === TABKEYCODE );

        if (!isTabPressed) { 
          console.log("exit trapFocus");
            return; 
        }
        
        if ( e.shiftKey ) /* shift tab keypress */ {
            if (document.activeElement === firstFocusableEl) {
                if (lastFocusableEl) lastFocusableEl.focus();
                e.preventDefault();
            }
        } else /* tab keypress */ {
            if (document.activeElement === lastFocusableEl) {
                firstFocusableEl.focus();
                e.preventDefault();
            }
        }
    });

}




  cookieBox();
  function cookieBox () {
    if($('#onetrust-banner-sdk').length > 0){
      $('#onetrust-banner-sdk').attr('aria-label', 'cookie banner');
      $('#onetrust-banner-sdk').attr('role', 'region');
    } else {
      setTimeout(cookieBox, 2000); //wait 50 ms, then try again
    }

    }




}); // end doc ready


